import { createBrowserHistory, History } from 'history'
const history: History = createBrowserHistory()

export function forwardTo(location: string) {
  history.push(location)
}

export default history
